String.prototype.toArabicDigits = function () {
  var id = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  return this.replace(/[0-9]/g, function (w) {
    return id[+w];
  });
};
export const dateFormat = (date, lang = 'en', isLong = true) => {
  let result;
  if (lang === 'en') {
    result = englishDateFormat(date, isLong);
  } else {
    result = arabicDateFormat(date);
  }
  return {
    ...result,
    'd m': `${result.day} ${result.month}`,
    'm y': `${result.month} ${result.year}`,
    'd m y': `${result.day} ${result.month} ${result.year}`,
    'm d y': `${result.month} ${result.day} ${result.year}`,
    'm d, y': `${result.month} ${result.day}, ${result.year}`,
    'y m d': `${result.year} ${result.month} ${result.day}`,
  };
};
const arabicDateFormat = (inputDate) => {
  const monthNames = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر',
  ];
  const date = new Date(inputDate);
  const day = date.getDate().toString().toArabicDigits();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear().toString().toArabicDigits();
  return {
    day,
    month,
    year,
    monthNumber: (date.getMonth() + 1).toString().toArabicDigits(),
  };
};
const englishDateFormat = (inputDate, isLong) => {
  const monthShortNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const monthFullNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const date = new Date(inputDate);
  const day = date.getDate();
  const month = !isLong ? monthShortNames[date.getMonth()] : monthFullNames[date.getMonth()];
  const year = date.getFullYear();
  return {
    day,
    month,
    year,
    monthNumber: date.getMonth() + 1,
  };
};

export const renderDate = (currentDate, lang, format) => {
  let date = new Date(currentDate);
  let transformedDate = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(date);

  let newDate = dateFormat(transformedDate, lang);
  return newDate[format];
};

var monthLongEn = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
var monthShortEn = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
var monthsAr = [
  'يناير',
  'فبراير',
  'مارس',
  'إبريل',
  'مايو',
  'يونيو',
  'يوليو',
  'أغسطس',
  'سبتمبر',
  'أكتوبر',
  'نوفمبر',
  'ديسمبر',
];

export const getDateName = (monthNumber, lang, type) => {
  let arrMonthes = [];

  if (lang === 'en') {
    if (type === 'short') {
      arrMonthes = monthShortEn;
    } else if (type === 'long') {
      arrMonthes = monthLongEn;
    }
  } else {
    arrMonthes = monthsAr;
  }
  return arrMonthes[monthNumber];
};

const lastday = (y, m) => {
  return new Date(y, m + 1, 0).getDate();
};
export const dateItemFormatting = (dateStart, dateEnd, lang, format, txt_yearOf) => {
  var lastDayInMonthOfProvidedDate = lastday(
    new Date(dateEnd)?.getFullYear(),
    new Date(dateEnd)?.getMonth()
  ); //convert utc to local date and get the last date of this month

  if (dateStart?.startsWith('0001') && dateEnd?.startsWith('0001')) {
    // or No Validity Start + No Validity End= Year of 2022 ==> current year
    return txt_yearOf.replace(`{0}`, new Date().getFullYear());
  }

  if (dateEnd?.startsWith('0001')) {
    // or No Validity End= Year of 2022 ==> current year
    return txt_yearOf.replace(`{0}`, new Date().getFullYear());
  }
  if (
    lastDayInMonthOfProvidedDate === new Date(dateEnd)?.getDate() &&
    new Date(dateEnd)?.getDate() !== 31 &&
    new Date(dateEnd)?.getMonth() !== 11
  ) {
    //if last day of the month is same as the provided date and its not 31 December
    return renderDate(dateEnd, lang, 'm y');
  }

  if (
    lastDayInMonthOfProvidedDate === new Date(dateEnd)?.getDate() &&
    new Date(dateEnd)?.getDate() === 31 &&
    new Date(dateEnd)?.getMonth() === 11
  ) {
    return txt_yearOf.replace(`{0}`, new Date(dateEnd)?.getFullYear());
  }

  if (lastDayInMonthOfProvidedDate === new Date(dateEnd)?.getDate()) {
    return renderDate(dateEnd, lang, 'm y');
  } else {
    return renderDate(dateEnd, lang, format);
  }
};
